<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">

      <WorkPackageHead
        :head="head"
        :background_color="bg"
        :foreground_color="fg"
        @selectStatus="selectStatus($event)"
      />

      <!-- DESCRIPTION -->
      <CollapsableCategory
        value="Description"
        :color="fg"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <div v-if="!is_collapsed">
              <TText
                :text="head.name"
                small
                :font_weight="500"
                :color="fg"
              />
              <TText
                :text="head.area"
                small
                :font_weight="500"
                :color="fg"
              />
              <TText
                :text="description"
                small
                :color="fg"
              />
            </div>
          </TransitionAccordion>
        </template>
      </CollapsableCategory>

      <!-- STEP LIST -->
      <CollapsableCategory
        value="Steps"
        :color="fg"
      >
        <template #content="{ is_collapsed }">
          <WorkPackageStepCategoryList
            :items="[
              {
                id: 0,
                step_type: 'LOGISTIC',
                progress: { done_count: 10, task_count: 12 },
              },
              {
                id: 1,
                step_type: 'DESIGN',
                progress: { done_count: 4, task_count: 6 },
              },
              {
                id: 2,
                step_type: 'WORK',
                progress: { done_count: 1, task_count: 10 },
              },
              {
                id: 3,
                step_type: 'QUALITY',
                progress: { done_count: 8, task_count: 10 },
              },
              {
                id: 4,
                step_type: 'DEFECT',
                progress: { done_count: 0, task_count: 3 },
              },
              {
                id: 5,
                step_type: 'HANDOVER',
                progress: { done_count: 2, task_count: 2 },
              },
              {
                id: 6,
                step_type: 'MATERIAL',
                progress: { done_count: 1, task_count: 2 },
              },
              {
                id: 7,
                step_type: 'MACHINE',
                progress: { done_count: 1, task_count: 3 },
              },
              {
                id: 8,
                step_type: 'SENSOR',
                progress: { done_count: 3, task_count: 4 },
              },
              {
                id: 9,
                step_type: 'ROBOTIC',
                progress: { done_count: 0, task_count: 0 },
              },
            ]"
            :has_lines="true"
            :is_collapsed="is_collapsed"
            :background_color="bg"
            :foreground_color="fg"
            :items_per_row="5"
          />
        </template>
      </CollapsableCategory>

      <!-- TIME RECORD -->
      <CollapsableCategory
        value="Time Record"
        :color="fg"
      >
        <template #content="{ is_collapsed }">
          <TimeRecord
            :equations="[
              {
                description: 'Min/Max',
                /* label (string), label_size (number), icon (string), text (string), operator (string) */
                elements: [
                  { label: 'Time effort', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true },
                  { icon: '', text: '', operator: '/'},
                  { label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true },
                  { icon: '', text: '', operator: '='},
                  { label: 'Duration', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true },
                ],
              },
              {
                description: 'Plan',
                /* label (string), label_size (number), icon (string), text (string), operator (string) */
                elements: [
                  { label: 'Time effort', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true },
                  { icon: '', text: '', operator: '/'},
                  { label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true },
                  { icon: '', text: '', operator: '='},
                  { label: 'Duration', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true },
                ],
              },
              {
                description: 'On Site',
                /* label (string), label_size (number), icon (string), text (string), operator (string) */
                elements: [
                  { label: 'Time Effort', icon: 'mdi-speedometer', text: '', operator: '', is_disabled: true },
                  { icon: '', text: '', operator: '='},
                  { label: 'Manpower', icon: 'mdi-human', text: '', operator: '', is_disabled: false },
                  { icon: '', text: '', operator: 'x'},
                  { label: 'Duration', icon: 'mdi-timer-outline', text: '', operator: '', is_disabled: false },
                ],
              }
            ]"
            :time_squares="[
              { description: 'Mo', is_badge: true, },
              { description: 'Tu', is_disabled: true, },
              { description: 'We', is_badge: true, },
              { description: 'Th', is_disabled: true, },
              { description: 'Fr', },
              { description: 'Sa', is_disabled: true, },
              { description: 'Su', is_disabled: true, },
              { is_invisible: true, },
              { is_invisible: true, },
              { description: '⌀', },
            ]"
            :is_collapsed="is_collapsed"
            :collapsed_equations="[
              {
                elements: [{ label: 'Manpower', icon: 'mdi-human', text: '1,00', operator: '', is_disabled: true }],
              },
              {
                elements: [{ label: 'Plan', icon: 'mdi-timer-outline', text: '35', operator: '', is_disabled: true }],
              },
              {
                elements: [{ label: 'On Site', icon: 'mdi-speedometer', text: '35', operator: '', is_disabled: true }],
              },
            ]"
            :background_color="bg"
            :foreground_color="fg"
          />
        </template>
      </CollapsableCategory>

      <!-- WIDGETS -->
      <CollapsableCategory
        value="Features"
        :color="fg"
        :is_disabled="true"
      >
      </CollapsableCategory>
    </div>
  </div>
</template>

<script>
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import WorkPackageStepCategoryList from '@/modules/WorkPackageWIP/WorkPackageStepCategoryList.module.vue';
import TimeRecord from  '@/modules/WorkPackageWIP/TimeRecord.module.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import WorkPackageHead from '@/modules/WorkPackageWIP/WorkPackageHead.module.vue';

  export default {
    components: {
      CollapsableCategory,
      TText,
      WorkPackageStepCategoryList,
      TimeRecord,
      TransitionAccordion,
      WorkPackageHead,
    },

    data: () => ({
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Mi tempus imperdiet nulla malesuada pellentesque elit eget. Massa tincidunt nunc pulvinar sapien. Faucibus vitae aliquet nec ullamcorper sit.',
      head: {
          icon: 'obj-door',
          // icon: 'title',
          token: 'EL1',
          name: 'Elektrotechnik, aber in einem langen Satz',
          area: 'Taktbereich B',
          status_done_count: 3,
          status_is_stop: 'ai_stop',
        },
      // show_warning: true,
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',
    }),

    methods: {
      selectStatus(state) {
        if(this.head.status_is_stop !== 'none') { // status is set to stop
          if(state.is_stop) { // if stop is pressed again
            this.head.status_is_stop = 'none'; // reset stop
          }
          else { // if any other status is pressed
            console.log('must turn off stop'); // don't change status
          }
        }
        else { // status is not set to stop
          if(state.is_stop) { // if next state is stop
            this.head.status_is_stop = 'stop'; // set stop status
          }
          else { // next status is either another status or set to no status
            this.head.status_is_stop = 'none';
            if(this.head.status_done_count === state.status_index) { // if status was already in place
              this.head.status_done_count = 0; // set status to no status
            }
            else { // a new status has been chosen
              this.head.status_done_count = state.status_index; // set status to new status
            }
          }
        }
      },
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
  }
</style>
